import { useMemo, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { MobileGame } from '../game';
import { GAME_NAME } from '../core/constants/urls';


export const MobileRoutes = () => {

  const components = useMemo(
    () => [
      { path: `${GAME_NAME}`, element: <MobileGame /> },
      { path: `*`, element: <Navigate to={`${GAME_NAME}`}/> },
    ],
    [],
  );

  return (
    <Routes>
      {components.map(({ path, element }) => {
        return <Route key={path} exact path={path} element={element}/>;
      })}
    </Routes>
  );
};